homeHandler = {
    video : {
        $pnlVideo : $('.panel-video'),
    },
    $carouselContainerAbout: $('.carousel-container-about'),
    $carouselChart: $('.carousel-chart'),
    $html: $('html'),
    /*
    flickityWheelEvent: function(e, flickityObj) {
        if (Foundation.MediaQuery.atLeast("medium")) {
            var direction = (Math.abs(e.deltaX) > Math.abs(e.deltaY)) ? e.deltaX : e.deltaY;
        
            if (direction > 0) {
                flickityObj.flickity('next');
            } else {
                flickityObj.flickity('previous');
            }
        }
    },
    */

    initCarousel: function(){
        var self = this;
        let $carContainer = $('.carousel-container');

        if ($carContainer.length > 0) {
            
            $carContainer.each(function(){
                let $car = $(this).flickity({
                    cellSelector: '.carousel-cell',
                    cellAlign: 'left',
                    pageDots: false,
                    fade: false,
                    wrapAround: false,
                    prevNextButtons: true,
                    draggable: true,
                });
                if ($car.length > 0) {
                    var flkty = $car.data('flickity');
                    var lastCell = flkty.cells.length;
                        
                    if (self.$carouselContainerAbout.length > 0) {
                        if (Foundation.MediaQuery.atLeast("medium")) {
                            lastCell = flkty.cells.length - 2;
                        }
                    }  
        
                    if (self.$carouselChart.length > 0) {
                        if (Foundation.MediaQuery.atLeast("medium")) {
                            lastCell = flkty.cells.length - 2;
                        }
                    }
        
                    // WCAG: Sync tabindex on focusable elements inside aria-hidden cells
                    // Flickity sets aria-hidden="true" on off-screen cells, but focusable
                    // elements inside them must also be removed from tab order.
                    function syncCellTabindex() {
                        $car.find('.carousel-cell').each(function() {
                            var $cell = $(this);
                            var isHidden = $cell.attr('aria-hidden') === 'true';
                            $cell.find('a, button, input, select, textarea, [tabindex]').each(function() {
                                if (isHidden) {
                                    $(this).attr('tabindex', '-1');
                                } else {
                                    $(this).removeAttr('tabindex');
                                }
                            });
                        });
                    }

                    $car.on( 'change.flickity', function( event, index ){
                        if ((self.$carouselChart.length > 0) || (self.$carouselContainerAbout.length > 0)) {
                            
                            var $btnNext = $('.carousel-container').find('.flickity-button.next');
                            if (index == lastCell) {
                                $btnNext.addClass('disabled');
                            } else {
                                $btnNext.removeClass('disabled');
                            }
                        }
                        
                        if ((index+1) > lastCell) {
                            event.preventDefault();
                            event.stopPropagation();
                            $car.flickity( 'selectCell', lastCell );
                        }

                        syncCellTabindex();
                    });

                    // Run once on init
                    syncCellTabindex();
                }  
            })
        }
            /*
            self.$carouselContainerAbout[0].onwheel = function(e) {
                e.preventDefault();
                if (!hasScrolled) {
                    hasScrolled = true;
                    setTimeout(() => {
                        self.flickityWheelEvent(e, $car);
                        hasScrolled = false;
                    }, 500);
                }
            };
            */    
    },

    init : function() {
        var self = this;
        setTimeout(() => {
            self.initCarousel();
        }, 1000);

        if (self.video.$pnlVideo.length > 0) {
            self.video.$pnlVideo.each(function() {
                let $this = $(this);
                let autoplay    = $this.find('.video-container video').attr('autoplay');
                let hasPopup    = $this.hasClass('is-popup');
                let popupVideo  = $this.find('.popup-video');
                let openPopup   = $this.find('[href="#open-popup-video"]');
                let closePopup  = $this.find('[href="#close-popup-video"]');
                let btnPlay     = $this.find('.button-play');
                let videoCont   = $this.find('.video-container');
                let videoEl     = $this.find('.video-container video');
                let videoElPopup= popupVideo.find('.video-container video');
                if (autoplay && !hasPopup) {
                    $this.find('.video-container').addClass('played');
                }

                closePopup.on('click', function(e) {
                    e.preventDefault();
                    popupVideo.removeClass('is-show');
                    self.$html.removeClass('disable-scroll');

                    videoElPopup[0].pause();
                });

                openPopup.on('click', function(e) {
                    e.preventDefault();
                    popupVideo.addClass('is-show');
                    self.$html.addClass('disable-scroll');

                    videoElPopup[0].play();
                });

                btnPlay.on('click', function(e) {
                    e.preventDefault();
                    if (!videoCont.hasClass('played')) {
                        videoEl[0].play();
                    } else {
                        videoEl[0].pause();
                    }
                    videoCont.toggleClass('played');
                });

                videoEl.on("pause", function () {
                    if (!hasPopup) {
                        videoCont.removeClass('played');
                        this.removeAttribute('controls');
                    }
                });
            
                videoEl.on("click", function () {
                    if (!hasPopup) {
                        videoCont.removeClass('played');
                        this.removeAttribute('controls');
                        this.pause();
                    }
                });
            });
        }
    }
}